export const SET_PA_PRESCRIBER_CROSSWALK_CLEAR_MESSAGE = 'clearMessage';
export const SET_PA_SEARCH_PRESCRIBER_CROSSWALK_COMPLETE = 'setPASearchPrescriberCrosswalk';
export const SET_PA_GET_PRESCRIBER_CROSSWALK_COMPLETE = 'setPAGetPrescriberCrosswalk';
export const SET_PA_PRESCRIBER_CROSSWALK_BUSY = 'setPAPrescriberCrosswalkBusy';



// WEBPACK FOOTER //
// ./src/store/prescriber-crosswalk/mutations.type.js